<style lang="scss" scoped>
.smalltext {
  margin-bottom: 10px;
}

.header {
  font-weight: bold;
}

.feedbackentry {
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  margin: 0px;
  &:nth-child(even) {
    background-color: $c-white;
  }
}

.detail-button {
  display: flex;
  align-items: center;
  gap: 15px;
}
</style>

<template>
  <div v-if="Object.keys(feedbacks).length > 0">
    <div class="row header smalltext">
      <div class="col-4">Skill</div>
      <div class="col-8">{{ $t('management.grades.state') }}</div>
    </div>
    <div class="row feedbackentry" :key="userid" v-for="(value, userid) of feedbacks">
      <div class="col-4">{{ value.user.firstname }} {{ value.user.lastname }}</div>
      <div class="col-8">
        {{ value.count > 1 ? `Noch ${value.count} Einschätzungen offen.` : `Noch ${value.count} Einschätzung offen.` }}
      </div>
      <!--<div class="col-2">
         <ModalButton :link="`delete_feedback_${skillid}_${feedback}_${grader}_${user}`">
          <Icon :width="35" :height="35" :path="mdiDelete" class="delete" />
        </ModalButton>
        <Modal :link="`delete_feedback_${skillid}_${feedback}_${grader}_${user}`" :title="$t('management.grades.modal')">
          <p>{{ $t('management.grades.confirm') }}</p>
           <p>
            <button @click="removeFeedback(skillid, value)">{{ $t('management.deleteconfirm') }}</button>
          </p> 
        </Modal> 
      </div>-->
    </div>
  </div>
  <div v-else>
    <p>Zur Zeit sind keine Einschätzungen mehr offen.</p>
  </div>

  <div class="row mt-5">
    <div class="col-5">
      <button @click="() => router.push({ name: 'AdminFeedbackDetails' })" class="detail-button">
        <Icon :width="35" :height="35" :path="mdiDelete" class="delete hover" />
        Einzelne Einschätzungen zurücksetzen oder löschen
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

import { mdiDelete } from '@mdi/js';
import { useRouter } from 'vue-router';

interface Skill {
  id: number;
  name: string;
  group: string;
  description: string;
  strategic: boolean;
}

interface UserData {
  [propName: number]: {
    // SKill ID
    target?: number; // Cached
    value?: number; // Cached
    leader?: number; // Cached
    self?: number; // Cached
    set?: number;
    detailed: {
      [propName: number]: number; // Cached <UserID>: Value
      history: {
        [propName: number]: {
          // Survey ID
          [propName: number]: number; // <UserID>: value
        };
      };
    };
  };
}

export default defineComponent({
  components: {
    // Modal,
    // ModalButton,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const skills = ref<Array<Skill>>();

    const grader = ref(0);
    const user = ref(0);
    const feedback = ref(0);
    const feedbacks = ref<
      Array<{
        user: any;
        count: number;
      }>
    >([]);
    const umfragen = ref();

    const init = () => {
      store.dispatch('API', { url: `admin/feedback` }).then((res: any) => {
        for (const index in res.data.message) {
          const grade = res.data.message[index];
          feedbacks.value = [...feedbacks.value, grade];
        }
        feedbacks.value = feedbacks.value.sort((a, b) => {
          if (a.count > b.count) return -1;
          if (b.count > a.count) return 1;
          return 0;
        });
      });
    };

    onMounted(() => {
      init();
    });

    const getSkillName = (id: number) => {
      return skills.value?.find((item: any) => item.id == id)?.name;
    };

    return {
      router,
      grader,
      user,
      umfragen,
      skills,
      feedback,
      feedbacks,
      getSkillName,
      mdiDelete,
    };
  },
});
</script>
